export default __webpack_public_path__ + "static/media/Circles_09.caf21ca4.png";